import isMatch from 'lodash/isMatch';
// This will do a deep check of the two objects and determine if they are equal
const areEqualObjects = (obj1: any, obj2: any) => isMatch(obj1, obj2);
const test = () => {};

export { areEqualObjects, test };
